import { combineReducers, type Reducer } from 'redux';

import { configReducer, langReducer, loginReducer } from './configuration';
import { configCatReducer } from './configuration/featureToggle/redux/configCat.redux';
import tokenHandlingReducer from './configuration/tokenHandling/reducer';
import { apiCallReducer } from './features/api/redux/api.redux';
import { appReducer } from './features/app/reducers/App.reducers';
import { dataReducer } from './features/data/redux/data.redux';
import { realtimeSidebarReducer } from './features/detailssidebar/redux/detailsSidebar.redux';
import { tableSettingsReducer } from './features/realtime/header/tablesettings/redux/tablesettings.redux';
import { realtimeReducer } from './features/realtime/redux/realtime.redux';
import { serviceInformationReducer } from './features/serviceInformation/serviceInformation.redux';
import { treeReducer } from './features/tree/redux/tree.redux';
import { widgetReducer } from './features/widget/redux/widget.redux';

export const rootReducer = (): Reducer =>
    combineReducers({
        serviceInformation: serviceInformationReducer,
        api: apiCallReducer,
        data: dataReducer,
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        realtime: combineReducers({
            table: realtimeReducer,
            sidebar: realtimeSidebarReducer,
        }),
        tokenHandling: tokenHandlingReducer,
        tableSettings: tableSettingsReducer,
        tree: treeReducer,
        widget: widgetReducer,
        configCat: configCatReducer,
    });

const tmp = rootReducer();
export type State = ReturnType<typeof tmp>;
